import { FormEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type Runbook } from '../../api/observability';

export function RunbookCenterPage() {
  const [runbooks, setRunbooks] = useState<Runbook[]>([]);
  const [title, setTitle] = useState('');
  const [stepTitle, setStepTitle] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => {
    void observabilityApi.runbooks().then(setRunbooks).catch((e) => setError(String(e)));
  };

  useEffect(() => { load(); }, []);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!title || !stepTitle) return;
    setSaving(true);
    try {
      await observabilityApi.createRunbook({
        title,
        steps: [{ order: 1, title: stepTitle, automated: false }],
      });
      setTitle('');
      setStepTitle('');
      load();
    } catch (err) {
      setError(String(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Runbook Center</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <form onSubmit={onSubmit} className="mt-4 space-y-3 rounded-lg border p-4 dark:border-slate-700">
        <h2 className="font-medium">Create Runbook</h2>
        <input className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" placeholder="Runbook title" value={title} onChange={(e) => setTitle(e.target.value)} />
        <input className="w-full rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" placeholder="First step title" value={stepTitle} onChange={(e) => setStepTitle(e.target.value)} />
        <button type="submit" disabled={saving} className="rounded bg-slate-900 px-4 py-2 text-sm text-white disabled:opacity-50 dark:bg-slate-100 dark:text-slate-900">
          {saving ? 'Saving…' : 'Create Runbook'}
        </button>
      </form>
      <ul className="mt-6 divide-y rounded-lg border dark:border-slate-700">
        {runbooks.map((rb) => (
          <li key={rb.id} className="px-4 py-3">
            <p className="font-medium">{rb.title}</p>
            <p className="text-sm text-slate-500">{rb.description}</p>
            <ol className="mt-2 list-decimal pl-5 text-sm text-slate-600 dark:text-slate-400">
              {rb.steps?.map((s) => <li key={s.order}>{s.title}</li>)}
            </ol>
          </li>
        ))}
      </ul>
    </div>
  );
}
